
import styled from 'styled-components'

export const Wrap = styled.div`
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 16px 16px 0 100px;
`;
export const RobotButton = styled.button<{ $isActive?: boolean }>`
  padding: 6px 12px;
  background: ${({ $isActive }) => ($isActive ? 'rgb(219, 234, 219)' : 'transparent')};
  // border: 1px solid ${({ $isActive }) => ($isActive ? 'rgb(124, 190, 123)' : 'rgb(217, 217, 217)')};
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  white-space: nowrap;
  transition: all 0.3s ease;
  user-select: none;
  color: ${({ $isActive }) => ($isActive ? 'black' : 'rgb(89, 89, 89)')};
  font-weight: ${({ $isActive }) => ($isActive ? 500 : 400)};

  /* Hover-эффект */
  &:hover {
    background: ${({ $isActive }) => ($isActive ? 'rgb(200, 220, 200)' : 'rgba(0, 0, 0, 0.04)')};
    border-color: ${({ $isActive }) => ($isActive ? 'rgb(100, 170, 100)' : 'rgb(140, 140, 140)')};
  }


  &:active {
    transform: translateY(1px);
    opacity: 0.95;
  }


  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    background: ${({ $isActive }) => ($isActive ? 'rgb(219, 234, 219)' : 'transparent')};
    border-color: ${({ $isActive }) => ($isActive ? 'rgb(124, 190, 123)' : 'rgb(217, 217, 217)')};
  }
`;
export const UnreadBadge = styled.span<{ color: string }>`
  position: absolute;
  top: -6px;
  left: -6px;
  min-width: 18px;
  height: 18px;
  background: ${({ color }) => color};
  color: white;
  font-size: 10px;
  font-weight: bold;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.3);
  border: 1.5px solid white;
  pointer-events: none; 
`;